/* jshint expr: true */

var winheight = window.innerHeight;
var History = window.History;
var app;
var isTouch = Modernizr.touch;

function App() {
	var self = this;
	this.photoswipe = false;
	this.mq = false;
	this.init();
}

App.prototype.init = function() {
	var self = this;
	this.handleWindowResize();
	this.ajaxHistory = new AjaxHistory();
	this.popups = new Popups();
	// this.handleChangeParkButton();
	// this.handleSelectParkMenu();
	$(window).on('resize', this, this.handleFixed);
	$(window).on('resize', this, this.handleWindowResize.bind(self));
	$(window).on('resize', this, this.handleBannerSubtitlePosition);
	self.map = new Map();
	this.initModules();
	
	var docTitle = $(document).find('title').html();
	this.historyArr = [[$('.page-container').html(), $('body').attr('class'), window.location.href, docTitle]];
	if (sessionStorage.getItem('historyArr')) {
		this.historyArr = JSON.parse(sessionStorage.getItem('historyArr'));
	} else {
		sessionStorage.setItem('historyArr', JSON.stringify(this.historyArr));
	}

	$(window).on('load', function() {
		$('body').addClass('-loaded');
	});

	self.getHomeInstagramFeed();

	$('a[href="#"]').on('click', function(e) {
		e.preventDefault();
	});
};

App.prototype.initModules = function() {
	var self = this;
	self.startAnimation = false;
	self.handleFixed();
	self.handleLoginForm();
	self.scroll = new Scroll();
	self.parallaxItems = new ParallaxItems();
	self.menu = new Menu();
	self.photoswipe = new initPhotoSwipe();
	self.slick = new Slick();
	self.popups = new Popups();
	self.waypoints = new Waypoints();
	self.handleBannerCounter();
	self.handlePriceCounter();
	self.handleCustomScroll();
	self.cookies = new Cookies();
	self.handleBannerSubtitlePosition();
	self.detectAnimationFinish();
	self.handleCanvasAnimations();
};

App.prototype.detectAnimationFinish = function() {
	var self = this;

	$('.logo-transform-container').on('animationend', function(e) {
		$('.logo-transform-container').removeClass('-animating');
		if (self.startAnimation) {
			setTimeout(function() {
				$('.logo-transform-container').addClass('-animating');
			}, 1);
		}
	});
};

App.prototype.handleCanvasAnimations = function() {
	var self = this;

	$(window).on('load', function() {
		$.each(canvasAnimations.stages, function(i, v) {
			v.getChildAt(0).play();
			v.interval = setInterval(function() {
				if (v.getChildAt(0).playing == 2) {
					// if ($('.reveal').length) {
					// 	self.rev.reveal();
					// }
					$('.banner .items-container').addClass('-loaded');
					clearInterval(v.interval);
				}
			}, 100);
		});
		if (!$('.banner .items-container').find('.banner-animation').length) {
			setTimeout(function() {
				// if ($('.reveal').length) {
				// 	self.rev.reveal();
				// }
				$('.banner .items-container').addClass('-loaded');
			}, 500);
		}
	});

	$('.ficon-newsletter-single').closest('.background-items').on('mouseenter', function() {
		canvasAnimations.bebenekStage.getChildAt(0).play();
	});
};

App.prototype.handleCustomScroll = function() {
	var self = this;
	// uwaga nie wiadomo dlaczego to poprawia scrollowanie popupow
	/*$('.header-menu-items').niceScroll({
		cursoropacitymax: 0.3,
		cursorborder: '0px solid transparent',
		horizrailenabled: false,
		bouncescroll: true,
		autohidemode: true
	});*/
	// $('.header-menu-items').on('touchmove', function(e) {
	// 	e.preventDefault();
	// });
};

App.prototype.handleChangeParkButton = function() {
	var self = this;
	$('body').on('click', '.parkselector .address-changepark', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$(this).closest('.park-info').toggleClass('-change-park');
	});
	$(document).on('click', function() {
		$('.park-info').removeClass('-change-park');
	});
	$('.address-popup .address-changepark a').on('click', function() {
		$('.park-info').removeClass('-change-park');
		$('body').addClass('-change-park');
	});
};

App.prototype.handleSelectParkMenu = function() {
	var self = this;
	$('.parkselector-selectpark').on('click', function() {
		var dataPark = $(this).attr('data-park');
		$('body').addClass('-change-park');
		$('body').removeClass('-home');
		$('body').removeClass('park-35').removeClass('park-36');
		$('body').addClass('park-'+dataPark);
		setTimeout(function() {
			$('body').removeClass('-change-park');
		}, 700);
	});
	$('.address-popup .address-changepark__trigger').on('click', function() {
		var dataPark = $(this).attr('data-park');
		$('body').addClass('-change-park');
		setTimeout(function() {
			$('body').removeClass('park-35').removeClass('park-36');
			$('body').addClass('park-'+dataPark);
			setTimeout(function() {
				$('body').removeClass('-change-park');
			}, 700);
		}, 500);
	});
};

App.prototype.handleBannerSubtitlePosition = function() {
	var self = this;
	var setPosition = setInterval(function() {
		if ($('.banner-slider-swipe').length) {
			$('.banner-slider-swipe').find('.slick-slide').each(function(i, v) {
				var that = $(this);
		        if (that.find('.title-container').find('span').length) {
		        	var height = that.find('.title-container').find('h1').outerHeight();
		        	var span = that.find('.title-container').find('span');
					span.css('top', (height - 30));
		        }
		    });
		}
	    if (!$('.banner-slider-swipe').length && $('section.banner').find('.items-container').find('.title-container').find('span').length) {
	    	var noSlideHeight = $('section.banner').find('.items-container').find('.title-container').find('h1').outerHeight();
	    	$('section.banner').find('.items-container').find('.title-container').find('span').css('top', (noSlideHeight - 30));
	    }
	}, 100);
	setTimeout(function() {
		clearInterval(setPosition);
	}, 2000);
};


Number.prototype.pad = function(size) {
  var s = String(this);
  while (s.length < (size || 2)) {s = "0" + s;}
  return s;
};

App.prototype.handleBannerCounter = function() {
	var self = this,
		target,
		daysAndHours = [
			['14', '21'],
			['14', '21'],
			['14', '21'],
			['14', '21'],
			['14', '21'],
			['10', '23'],
			['10', '22'],
		],
		dateNow = new Date(),
		today = dateNow.getDay(),
		hour = dateNow.getHours(),
		nextDay = today+1,
		compareDate,
		ctaText;
	
	if ($('.banner .items-container .text p').text() == "{counter}")
		target = $('.banner .items-container .text p');
	else if ($('.counter').length)
		terget = $('.counter');
	else
		return 0;

	if (nextDay == 7)
		nextDay = 0;

	if (hour >= daysAndHours[today][0] && hour < daysAndHours[today][1]) {
		// open
		ctaText = "Otwarte jeszcze ";
		compareDate = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate(), daysAndHours[today][1], 0, 0);
	} else {
		// closed
		ctaText = "Otwieramy za ";
		compareDate = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate()+1, daysAndHours[nextDay][0], 0, 0);
	}

	setInterval(function() {
		var now = new Date();
		var difference = compareDate.getTime() - now.getTime();

		if (difference > 0) {
			var seconds = Math.floor(difference / 1000),
				minutes = Math.floor(seconds / 60),
				hours = Math.floor(minutes / 60),
				days = Math.floor(hours / 24);

			(hours % 24) ? hours = (hours%24).pad(1)+'h ' : hours = '';
			(minutes % 60) ? minutes = (minutes%60).pad(1)+'m ' : minutes = '00m ';
			(seconds % 60) ? seconds = (seconds%60).pad(2)+'s' : seconds = '00s';

			target.html(ctaText+'<span>'+hours+minutes+seconds+'</span>');
		}
	}, 1000);
};

App.prototype.handlePriceCounter = function() {
	var self = this;
	$('.pricelist-group-item').each(function() {
		var priceNumber = $(this).find('.largetext').text().match(/[+-]?\d+(?:\.\d+)?/g);
		if (priceNumber) {
			priceNumber = priceNumber[0];
			console.log(priceNumber);
			$(this).find('.largetext').contents().eq(priceNumber).wrap('<span />');
			if ($(this).find('.largetext').hasClass('time')) {
				$(this).find('.largetext').animateNumber({
					number: priceNumber,
					numberStep: function(now, tween) {
						var floored_number = Math.floor(now),
						target = $(tween.elem);

						target.text(floored_number + 'min.');
					}
				}, 2000);
			} else if ($(this).find('.largetext').hasClass('pln')) {
				$(this).find('.largetext').animateNumber({
					number: priceNumber,
					numberStep: function(now, tween) {
						var floored_number = Math.floor(now),
						target = $(tween.elem);

						target.text(floored_number + ' zł');
					}
				}, 2000);
			} else {
				$(this).find('.largetext').animateNumber({
					number: priceNumber,
					numberStep: function(now, tween) {
						var floored_number = Math.floor(now),
						target = $(tween.elem);

						target.text(floored_number + ' zł/h');
					}
				}, 2000);
			}
		}
	});
	$('.passes-item').each(function() {
		var passesNumber = $(this).find('.largetext').text().match(/[+-]?\d+(?:\.\d+)?/g);
		if (passesNumber) {
			passesNumber = passesNumber[0];
			if (!$(this).find('.largetext').hasClass('time')) {
				$(this).find('.largetext').animateNumber({
					number: passesNumber,
					numberStep: function(now, tween) {
						var floored_number = Math.floor(now),
						target = $(tween.elem);

						target.text(floored_number + ' zł');
					}
				}, 2000);
			} else {
				$(this).find('.largetext').animateNumber({
					number: passesNumber,
					numberStep: function(now, tween) {
						var floored_number = Math.floor(now),
						target = $(tween.elem);

						target.text(floored_number + 'min.');
					}
				}, 2000);
			}
		}
	});
};

App.prototype.getHomeInstagramFeed = function() {
	var self = this;
	
	$.ajax({
		type: 'GET',
		url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=3226108614.83b5d2b.26279f4d97d4477e873d9d8f54f90dc9&count=8',
		success: function(data) {
			var loaded = 1;
			for (var i = 0; i < data.data.length; i++) {
				
				var postLink,
					likesCount,
					captionTextvar,
					shortCaptionLength,
					shortCaptionText,
					imgURL,
					div,
					img,
					likes,
					caption,
					shortCaption,
					followLink,
					followDiv,
					followDiv2,
					followA,
					followText,
					span,
					iconContainer,
					icon;

				if(i == 7) {
					//add follow link
					followLink = data.data[i].link;
					followDiv = document.createElement('div');
					followDiv2 = document.createElement('div');
					followA = document.createElement('a');
		        
					$(followDiv).attr('class','column instapic -follow -scroll-wpt1');
					$('#insta-feed').append(followDiv);

					$(followDiv).append(followDiv2);

					followText = 'Obserwuj nas i bądź na bieżąco!';
					span = '<span>@saltostrampoliny</span>';
					$(followA).text(followText);
					$(followA).attr('href', 'https://www.instagram.com/saltostrampoliny/');
					$(followA).attr('target', '_blank');
					$(followA).append(span);
					$(followDiv2).append(followA);

					//continue as normal
					postLink = data.data[i].link;
					likesCount = data.data[i].likes.count;
					captionText = data.data[i].caption.text;
					shortCaptionLength = 160;
					shortCaptionText = data.data[i].caption.text.substr(0, shortCaptionLength);
					shortCaptionText = shortCaptionText.substr(0, Math.min(shortCaptionText.length, shortCaptionText.lastIndexOf(" ")));
					imgURL = data.data[i].images.standard_resolution.url;
					div = document.createElement('a');
					iconContainer = document.createElement('span');
					icon = document.createElement('span');

					$(div).attr('class','column instapic -scroll-wpt1');
					$(div).attr('href', postLink);
					$(div).attr('target', '_blank');
					$('#insta-feed').append(div);

					$(div).append(iconContainer);
					$(icon).attr('data-depth', '1');
					$(iconContainer).attr('class', 'ficon-instagram');
					$(iconContainer).append(icon);

					img = document.createElement('img');
					$(div).append(img);
					$(img).attr('data-src', imgURL);
					$(img).attr('src', '');

					likes = document.createElement('div');
					$(likes).attr('class', 'likes');
					$(likes).html('<span>'+likesCount+'</span>');
					$(div).append(likes);

					caption = document.createElement('p');
					$(caption).attr('class', 'caption -visible-large');
					$(caption).html(captionText);
					$(div).append(caption);

					shortCaption = document.createElement('p');
					$(shortCaption).attr('class', 'caption -visible-medium');
					if (shortCaptionText.length < captionText.length) {
						$(shortCaption).html(shortCaptionText+'...');
					} else {
						$(shortCaption).html(shortCaptionText);
					}
					$(div).append(shortCaption);
				} else {
					postLink = data.data[i].link;
					likesCount = data.data[i].likes.count;
					captionText = data.data[i].caption.text;
					imgURL = data.data[i].images.standard_resolution.url;
					shortCaptionLength = 160;
					shortCaptionText = data.data[i].caption.text.substr(0, shortCaptionLength);
					shortCaptionText = shortCaptionText.substr(0, Math.min(shortCaptionText.length, shortCaptionText.lastIndexOf(" ")));
					div = document.createElement('a');
					iconContainer = document.createElement('span');
					icon = document.createElement('span');
		        
					$(div).attr('class','column instapic -scroll-wpt1');
					$(div).attr('href', postLink);
					$(div).attr('target', '_blank');
					$('#insta-feed').append(div);

					$(div).append(iconContainer);
					$(icon).attr('data-depth', '1');
					$(iconContainer).attr('class', 'ficon-instagram');
					$(iconContainer).append(icon);

					img = document.createElement('img');
					$(div).append(img);
					$(img).attr('src', '');
					$(img).attr('data-src', imgURL);

					likes = document.createElement('div');
					$(likes).attr('class', 'likes');
					$(likes).html('<span>'+likesCount+'</span>');
					$(div).append(likes);

					caption = document.createElement('p');
					$(caption).attr('class', 'caption -visible-large');
					$(caption).html(captionText);
					$(div).append(caption);

					shortCaption = document.createElement('p');
					$(shortCaption).attr('class', 'caption -visible-medium');
					if (shortCaptionText.length < captionText.length) {
						$(shortCaption).html(shortCaptionText+'...');
					} else {
						$(shortCaption).html(shortCaptionText);
					}
					$(div).append(shortCaption);
				}
			}		
			var loadedAll = $('.instapic').length;
			$('.-scroll-wpt1').each(function(i, el) {
				el.waypoint = new Waypoint({
					element: el,
					handler: function(dir) {
						var imgSrc = $(el).find('img').attr('data-src');
						if (!$(el).hasClass('-active')) {
							$(el).addClass('-active');
							$(el).find('img').attr('src', imgSrc);
						}
					},
					offset: '90%'
				});
			});

			$('#insta-feed *[class*=ficon-]').each(function() {
				var that = this;
				if (typeof that.iconsParallax === 'undefined') {
					that.iconsParallax = new Parallax(that);
				}
				setTimeout(function() {
					if (app.mq == "medium" || app.mq == "small") {
						that.iconsParallax.scalar(-10 + 20*Math.random(), -10 + 20*Math.random());
					} else {
						that.iconsParallax.scalar(-15 + 30*Math.random(), -15 + 30*Math.random());
					}
				}, 500);
			});
			// $('.instapic img').on('load', function() {
			// 	loaded++;
			// 	if (loaded == loadedAll) {
			// 		$('.-scroll-wpt1').each(function(i, el) {
			// 			el.waypoint = new Waypoint({
			// 				element: el,
			// 				handler: function(dir) {
			// 					if (!$(el).hasClass('-active')) {
			// 						$(el).addClass('-active');
			// 					}
			// 				},
			// 				offset: '75%'
			// 			});
			// 		});

			// 		$('#insta-feed *[class*=ficon-]').each(function() {
			// 			var that = this;
			// 			if (typeof that.iconsParallax === 'undefined') {
			// 				that.iconsParallax = new Parallax(that);
			// 			}
			// 			setTimeout(function() {
			// 				if (app.mq == "medium" || app.mq == "small") {
			// 					that.iconsParallax.scalar(-10 + 20*Math.random(), -10 + 20*Math.random());
			// 				} else {
			// 					that.iconsParallax.scalar(-15 + 30*Math.random(), -15 + 30*Math.random());
			// 				}
			// 			}, 500);
			// 		});
			// 	}
			// });
			// $('.instapic').each(function() {
			// 	var imgSrc = $(this).find('img').attr('data-src');
			// 	$(this).find('img').attr('src', imgSrc);
			// });			
		},
	});
};

App.prototype.handleLoginForm = function() {
	var self = this;
	if ($('form#login').length) {
		$('form#login input[type="text"]').focus();
	}
	$('form#login').on('input focus', function() {
		if ($(this).find('input[type="text"]').val() != "" && $(this).find('input[type="password"]').val() != "") {
			$(this).closest('.form').addClass('-filled');
		} else if (!$(this).find('input[type="text"]').val() || !$(this).find('input[type="password"]').val()) {
			$(this).closest('.form').removeClass('-filled');
		}
	});
};

App.prototype.handleFixed = function() {
	var self = this;
};

App.prototype.handleWindowResize = function(e) {
	var self = this;
	self.mq = /\w+/g.exec(window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content'))[0];
	winheight = window.innerHeight;
	var scrollInt = setInterval(function() {
		$(window).trigger('scroll');
	}, 100);
	setTimeout(function() {
		clearInterval(scrollInt);
	}, 1000);
};

$(document).ready(function() {
	app = new App();
});